import React, { createElement } from 'react';
import './index.css';
import { createRoot } from 'react-dom/client';
import { App } from './App';
// Load the Inter web font as early as possible in the boot sequence.
// Preconnecting to Google's font origins warms the DNS/TLS handshake before the
// font stylesheet is requested, and issuing the stylesheet <link> directly (rather
// than via a chained CSS @import) lets it download in parallel with the app CSS.
// Together these shrink the blank-screen gap between "load bar done" and first paint.
function loadFonts() {
  const head = document.head;
  if (head.querySelector('link[data-inter-font]')) return;
  const preconnectGoogle = document.createElement('link');
  preconnectGoogle.rel = 'preconnect';
  preconnectGoogle.href = 'https://fonts.googleapis.com';
  const preconnectGstatic = document.createElement('link');
  preconnectGstatic.rel = 'preconnect';
  preconnectGstatic.href = 'https://fonts.gstatic.com';
  preconnectGstatic.crossOrigin = 'anonymous';
  const stylesheet = document.createElement('link');
  stylesheet.rel = 'stylesheet';
  stylesheet.dataset.interFont = 'true';
  stylesheet.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&display=swap';
  head.appendChild(preconnectGoogle);
  head.appendChild(preconnectGstatic);
  head.appendChild(stylesheet);
}
loadFonts();
const container = document.getElementById('root');
if (container) {
  createRoot(container).render(<App data-id="element-184" />);
}